export const spring = {
  gentle: { type: 'spring', stiffness: 120, damping: 14 },
  bouncy: { type: 'spring', stiffness: 300, damping: 10 },
  snappy: { type: 'spring', stiffness: 400, damping: 20 },
  celebration: { type: 'spring', stiffness: 400, damping: 8 },
};

export const duration = {
  instant: 0.1,
  fast: 0.2,
  normal: 0.3,
  slow: 0.5,
  celebration: 0.8,
};

export const fadeIn = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.2 },
};

export const slideUp = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -10 },
  transition: spring.gentle,
};

export const slideInRight = {
  initial: { opacity: 0, x: 30 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -30 },
  transition: spring.gentle,
};

export const scaleIn = {
  initial: { opacity: 0, scale: 0.9 },
  animate: { opacity: 1, scale: 1 },
  exit: { opacity: 0, scale: 0.9 },
  transition: spring.bouncy,
};

export const popIn = {
  initial: { opacity: 0, scale: 0.5 },
  animate: { opacity: 1, scale: 1 },
  exit: { opacity: 0, scale: 0.5 },
  transition: spring.celebration,
};

export const tapScale = {
  whileHover: { scale: 1.05 },
  whileTap: { scale: 0.95 },
  transition: spring.snappy,
};

export const tapBounce = {
  whileHover: { scale: 1.08, y: -2 },
  whileTap: { scale: 0.92 },
  transition: spring.bouncy,
};

export const correctAnswer = {
  initial: { scale: 1 },
  animate: {
    scale: [1, 1.2, 1],
    backgroundColor: ['var(--color-finley-bg-card)', 'var(--color-finley-success)', 'var(--color-finley-bg-card)'],
  },
  transition: { duration: 0.5, ease: 'easeInOut' },
};

export const wrongAnswer = {
  animate: {
    x: [0, -8, 8, -8, 8, 0],
    transition: { duration: 0.4 },
  },
};

export const staggerContainer = {
  animate: {
    transition: {
      staggerChildren: 0.08,
    },
  },
};

export const staggerChild = {
  initial: { opacity: 0, y: 15 },
  animate: { opacity: 1, y: 0 },
  transition: spring.gentle,
};

export const screenTransition = {
  initial: { opacity: 0, x: 20 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -20 },
  transition: { duration: 0.25, ease: 'easeInOut' },
};
